module.exports = __webpack_public_path__ + "static/5-baa9a23c6636478a92cf3d760e96eedc.png";